import React from 'react';
import { useSiteMetadata } from '@/hooks/useSiteMetadata';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  lang?: string;
  children?: React.ReactNode;
}

const SEO: React.FC<SEOProps> = ({ title, description, image, children }) => {
  const siteMetadata = useSiteMetadata();

  const metaDescription = description || siteMetadata.description;
  const defaultTitle = siteMetadata?.title;
  const metaImage = image || siteMetadata.image;
  const linkedInUrl = siteMetadata.linkedInUrl;

  return (
    <>
      <title>{title ? `${defaultTitle} | ${title}` : defaultTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={siteMetadata.siteUrl} />
      <meta property="og:linkedin" content={linkedInUrl} />
      <link rel="apple-touch-icon" href="src/images/favicons/apple-icon.png" />
      <link
        rel="apple-touch-icon-precomposed"
        href="src/images/favicons/apple-icon-precomposed.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="57x57"
        href="src/images/favicons/apple-icon-57x57.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="60x60"
        href="src/images/favicons/apple-icon-60x60.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="72x72"
        href="src/images/favicons/apple-icon-72x72.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="76x76"
        href="src/images/favicons/apple-icon-76x76.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href="src/images/favicons/apple-icon-114x114.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href="src/images/favicons/apple-icon-120x120.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="128x128"
        href="src/images/favicons/apple-icon-57x57.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="144x144"
        href="src/images/favicons/apple-icon-144x144.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href="src/images/favicons/apple-icon-152x152.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="src/images/favicons/apple-icon-180x180.png"
      />
      {children}
    </>
  );
};

export default SEO;
